import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";

export default function AboutPhotoAdmin() {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const load = () => api.get("/public/about").then((r) => setUrl(r.data.photo_url));
  useEffect(() => { load(); }, []);
  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try { await api.post("/admin/about-photo", fd); toast.success("Fotografija je posodobljena."); load(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const remove = async () => {
    try { await api.delete("/admin/about-photo"); setUrl(null); toast.success("Fotografija je odstranjena."); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="card-lux p-6 mt-8 flex flex-col sm:flex-row gap-6 items-start" data-testid="about-photo-admin">
      <div className="w-40 aspect-[4/5] rounded-2xl bg-[#F3ECE1] overflow-hidden shrink-0">
        {url ? <img src={fileUrl(url)} alt="O naju" className="w-full h-full object-cover" data-testid="about-photo-admin-preview" /> : <p className="text-xs text-[#968E87] p-4">Ni fotografije</p>}
      </div>
      <div className="space-y-3">
        <h3 className="font-display text-2xl">Fotografija na strani »O naju«</h3>
        <p className="text-sm text-[#6C6560]">Naložite svojo resnično fotografijo (JPG, PNG, WEBP ali HEIC). Prikaže se na strani /o-naju.</p>
        <input ref={input} type="file" accept="image/*,.heic,.heif" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="about-photo-input" />
        <div className="flex gap-2">
          <button disabled={busy} onClick={() => input.current?.click()} className="btn-dark px-5 py-2.5 text-sm disabled:opacity-50" data-testid="about-photo-upload-button">{busy ? "Nalaganje …" : url ? "Zamenjaj fotografijo" : "Naloži fotografijo"}</button>
          {url && <button onClick={remove} className="btn-line px-5 py-2.5 text-sm" data-testid="about-photo-remove-button">Odstrani</button>}
          <a href="/o-naju" target="_blank" rel="noreferrer" className="btn-line px-5 py-2.5 text-sm">Odpri stran</a>
        </div>
      </div>
    </div>
  );
}
